import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HomeFinds from "../pages/home-finds/page";
import BeautyEssentials from "../pages/beauty-essentials/page";
import TravelMustHaves from "../pages/travel-must-haves/page";
import ForTheMen from "../pages/for-the-men/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/home-finds",
    element: <HomeFinds />,
  },
  {
    path: "/beauty-essentials",
    element: <BeautyEssentials />,
  },
  {
    path: "/travel-must-haves",
    element: <TravelMustHaves />,
  },
  {
    path: "/for-the-men",
    element: <ForTheMen />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
